(() => {
  'use strict';
  const script = document.currentScript || document.querySelector('script[data-checkout-origin]');
  if (!script) return;
  let origin;
  try {
    const configured = new URL(script.dataset.checkoutOrigin);
    // Do not send cart data to a different tenant or to an arbitrary theme-setting URL.
    if (configured.protocol !== 'https:' || configured.hostname !== 'checkout.hatchill.com' || configured.port || configured.username || configured.password) return;
    origin = configured.origin;
  } catch { return; }
  const root = window.Shopify?.routes?.root || '/';
  const quietSaleParams=(intent,automatic=false)=>{if(script.dataset.personalOfferEnabled==='false')return '';const codes=['FLASH20','YOUR-OFFER'];if(codes.includes(intent))return '&hc_discount='+intent;try{const selected=String(document.cookie||'').split(';').map(v=>v.trim()).find(v=>v.startsWith('hc_quiet_sale_selected='))?.split('=')[1];if(codes.includes(selected))return '&hc_discount='+selected;return automatic&&globalThis.HatchillQuietSaleOffer?.checkoutIntent?.()?'&hc_offer='+(globalThis.HatchillQuietSaleOffer.checkoutCode?.()||'FLASH20'):'';}catch{return '';}};
  // Prime Shopify's documented privacy API without adding a checkout banner or
  // holding up navigation if the API is unavailable.
  function privacySnapshot(){
    try{
      const privacy=window.Shopify.customerPrivacy;
      const values=[privacy.marketingAllowed(),privacy.saleOfDataAllowed(),privacy.analyticsProcessingAllowed()];
      if(!values.every(value=>typeof value==='boolean'))return null;
      const refused=typeof navigator!=='undefined'&&navigator.globalPrivacyControl===true,observedAt=Date.now();
      const snapshot={v:1,allowed:!refused&&values[0]&&values[1],analytics:!refused&&values[2],observedAt,expiresAt:observedAt+86400000};
      if(['www.hatchill.com','hatchill.com'].includes(new URL(location.href).hostname))document.cookie=`hc_privacy=${encodeURIComponent(JSON.stringify(snapshot))}; Domain=hatchill.com; Path=/; Max-Age=86400; Secure; SameSite=Lax`;
      return snapshot;
    }catch{return null;}
  }
  const attributionKey='hatchill:meta-attribution:v1';
const campaignKeys=['utm_source','utm_medium','utm_campaign','utm_content','utm_term','utm_id','campaign_id','adset_id','ad_id','placement'];
function safeCampaignLocation(value,landing=false){
 try{
  const url=new URL(value);if(!['https:','http:'].includes(url.protocol)||url.username||url.password||url.port)return '';
  const owned=['www.hatchill.com','hatchill.com','checkout.hatchill.com','account.hatchill.com','bonsai-eg.myshopify.com'].includes(url.hostname);
  if(landing&&!owned)return '';
  if(!owned)return url.origin+'/';
  const path=decodeURIComponent(url.pathname);
  const route=path.replace(/^\/[a-z]{2}(?=\/|$)/,'')||'/';
  const clean=/^\/(?:products|collections|pages|policies)\/[\p{L}\p{N}_-]{1,150}\/?$/u.test(route) ||
   /^\/collections\/[\p{L}\p{N}_-]{1,150}\/products\/[\p{L}\p{N}_-]{1,150}\/?$/u.test(route) ||
   /^\/blogs\/[\p{L}\p{N}_-]{1,150}(?:\/[\p{L}\p{N}_-]{1,150})?\/?$/u.test(route) ||
   /^\/(?:cart|search|collections|apps\/track|order-confirmation)?\/?$/.test(route);
  const safe=/^\/(?:checkouts?|orders)(?:\/|$)/.test(route)?(route.startsWith('/orders')?'/order-confirmation':'/checkout')
   :url.hostname==='account.hatchill.com'||/^\/account(?:\/|$)/.test(route)?'/account':clean?url.pathname:'/';
  return (url.origin+safe).slice(0,1024);
 }catch{return '';}
}
function normalizeCampaignTouch(value){
 if(!value||typeof value!=='object'||Array.isArray(value))return {};
 const result={};
 for(const key of ['landingPage','referrer']){const v=safeCampaignLocation(value[key],key==='landingPage');if(v)result[key]=v;}
 for(const key of campaignKeys){
  const v=typeof value[key]==='string'?value[key].trim():'';
  let decoded=v;try{for(let n=0;n<2;n++)decoded=decodeURIComponent(decoded);}catch{continue;}
  if(!v||v.length>200||/[\u0000-\u001f@/?&#=\\]/.test(decoded)||/https?:|(?:token|secret|password|email)=/i.test(decoded))continue;
  if(['campaign_id','adset_id','ad_id'].includes(key)&&!/^\d{1,30}$/.test(v))continue;
  result[key]=v;
 }
 return result;
}
function navigationCampaign(previous,fresh,newClick=false){
 const before=normalizeCampaignTouch(previous),next=normalizeCampaignTouch(fresh);
 return newClick||campaignKeys.some(key=>next[key])||!before.landingPage?next:before;
}
  function captureTouch(){
    try{
      privacySnapshot();
      const privacy=window.Shopify?.customerPrivacy;
      if(!privacy)return null;
      if(navigator.globalPrivacyControl||privacy.marketingAllowed()!==true||privacy.saleOfDataAllowed()!==true){localStorage.removeItem(attributionKey);return null;}
      const now=Date.now(),params=new URLSearchParams(location.search),cookie=key=>{try{return decodeURIComponent(document.cookie.split(';').map(c=>c.trim()).find(c=>c.startsWith(key+'='))?.slice(key.length+1)||'');}catch{return '';}};
      const validCookie=(value,type)=>{const m=value.match(type==='fbc'?/^fb\.\d\.(\d{13})\.([A-Za-z0-9_.=-]{5,512})$/:/^fb\.\d\.(\d{13})\.(\d{5,30})$/);return m&&Number(m[1])<=now+300000&&Number(m[1])>0&&(type==='fbp'||Number(m[1])>now-90*86400000)?value:'';};
      let saved;try{saved=JSON.parse(localStorage.getItem(attributionKey)||'null');}catch{}
      if(!saved||saved.expiresAt<=now)saved=null;
      const click=params.get('fbclid'),fresh={landingPage:location.href,referrer:document.referrer};
      for(const key of campaignKeys)fresh[key]=params.get(key);
      const lastTouch={...Object.fromEntries(Object.entries(saved?.lastTouch||{}).filter(([key])=>['fbp','fbc','fbclid'].includes(key))),...navigationCampaign(saved?.lastTouch,fresh,!!click&&saved?.lastTouch?.fbclid!==click)};
      const fbp=validCookie(cookie('_fbp'),'fbp'),fbc=validCookie(cookie('_fbc'),'fbc');if(fbp)lastTouch.fbp=fbp;if(fbc&&(!lastTouch.fbc||Number(fbc.split('.')[2])>=Number(lastTouch.fbc.split('.')[2]))){lastTouch.fbc=fbc;lastTouch.fbclid=fbc.split('.').slice(3).join('.');}
      if(click&&/^[A-Za-z0-9_.=-]{5,512}$/.test(click)){lastTouch.fbclid=click;if(!lastTouch.fbc||lastTouch.fbc.split('.').slice(3).join('.')!==click)lastTouch.fbc=`fb.1.${now}.${click}`;}
      const result={...lastTouch,firstTouch:saved?.firstTouch||lastTouch,expiresAt:now+30*86400000};
      try{localStorage.setItem(attributionKey,JSON.stringify({firstTouch:result.firstTouch,lastTouch,expiresAt:result.expiresAt}));}catch{}
      return result;
    }catch{return null;}
  }
  captureTouch();document.addEventListener('visitorConsentCollected',captureTouch);
  const privacyParams=()=>{
    try{
      const privacy=window.Shopify.customerPrivacy;
      const values=[privacy.marketingAllowed(),privacy.saleOfDataAllowed(),privacy.analyticsProcessingAllowed()];
      if(!values.every(value=>typeof value==='boolean'))return '';
      privacySnapshot();
      return `&hc_marketing=${values[0]?1:0}&hc_sale=${values[1]?1:0}&hc_analytics=${values[2]?1:0}&hc_privacy_at=${Date.now()}`;
    }catch{return '';}
  };
  const attributionParams=()=>{try{const touch=captureTouch();if(touch){const encoded=btoa(String.fromCharCode(...new TextEncoder().encode(JSON.stringify(touch)))).replace(/\+/g,'-').replace(/\//g,'_').replace(/=+$/,'');if(encoded.length<=8000)return '&hc_meta='+encoded;}}catch{}return '';};
  const measuredLink=href=>{
    const url=new URL(href),params=new URLSearchParams(url.hash.slice(1));
    if(!params.get('hc_discount')&&quietSaleParams())params.set('hc_discount',new URLSearchParams(quietSaleParams()).get('hc_discount'));
    for(const key of ['hc_marketing','hc_sale','hc_analytics','hc_privacy_at','hc_meta'])params.delete(key);
    const fresh=new URLSearchParams((privacyParams()+attributionParams()).replace(/^&/,''));
    for(const [key,value] of fresh)params.set(key,value);
    url.hash=params.toString();return url.href;
  };
  let busy = false;
  const watchKey='hatchill:checkout-carts:v1',cleanupKey='hatchill:cart-cleanup:v1';
  const readStored=key=>{try{const value=JSON.parse(localStorage.getItem(key)||'[]');return Array.isArray(value)?value:[];}catch{return [];}};
  const writeStored=(key,value)=>{try{localStorage.setItem(key,JSON.stringify(value));return true;}catch{return false;}};
  const supported=item=>!item.selling_plan_allocation&&!Object.keys(item.properties||{}).length&&!item.gift_card&&!item.item_components?.length;
  const quantity=(cart,key)=>cart.items.find(item=>item.key===key)?.quantity||0;
  const cartRead=async()=>{const r=await fetch(`${root}cart.js`,{credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(1500)});if(!r.ok)throw Error('cart');return r.json();};
  let cleaning;
  async function cleanup(proof,snapshot){
    if(proof.confirmed!==true||!/^gid:\/\/shopify\/Order\/\d+$/.test(proof.orderId||'')||!Array.isArray(proof.lines))return;
    const records=readStored(cleanupKey).filter(r=>!r.createdAt||r.createdAt>Date.now()-31*24*3600000);let record=records.find(r=>r.orderId===proof.orderId);
    if(record?.done)return;
    let cart=await cartRead();
    if(snapshot?.cartToken&&cart.token!==snapshot.cartToken)return;
    if(!record){
      if(!snapshot)return; // A legacy receipt alone cannot identify the original cart.
      const updates={},before={};
      for(const line of proof.lines){
        const id=String(line.variantId).replace('gid://shopify/ProductVariant/','');
        if(!/^\d+$/.test(id)||!Number.isInteger(line.quantity)||line.quantity<1||line.quantity>10)return;
        const originals=snapshot?.items?.filter(i=>String(i.variantId)===id)||[];
        const candidates=cart.items.filter(i=>String(i.variant_id)===id&&supported(i)&&(!snapshot||originals.some(o=>o.key===i.key)));
        // Customized lines and ambiguous variants must never be removed.
        if(candidates.length!==1)continue;
        const item=candidates[0];before[item.key]=item.quantity;updates[item.key]=Math.max(0,item.quantity-line.quantity);
      }
      record={orderId:proof.orderId,before,updates,done:false,createdAt:Date.now()};records.push(record);
      if(!writeStored(cleanupKey,records))return;
    }
    const entries=Object.entries(record.updates);
    if(entries.every(([key,after])=>quantity(cart,key)===after)){record.done=true;writeStored(cleanupKey,records);return;}
    if(!entries.every(([key])=>quantity(cart,key)===record.before[key]))return;
    // Persist absolute target quantities before mutation. If its response is lost,
    // readback detects success instead of subtracting the purchased quantity twice.
    let rendered;
    try{const response=await fetch(`${root}cart/update.js`,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},signal:AbortSignal.timeout(1500),body:JSON.stringify({updates:record.updates,sections:['main-cart-items','main-cart-footer','cart-drawer','cart-icon-bubble']})});if(response.ok)rendered=await response.json();}catch{}
    cart=await cartRead();
    if(entries.every(([key,after])=>quantity(cart,key)===after)){
      record.done=true;writeStored(cleanupKey,records);
      document.dispatchEvent(new CustomEvent('cart:updated',{detail:{...cart,sections:rendered?.sections}}));
      // Cart pages need fresh server-rendered rows; other pages keep their location.
      if(location.pathname.replace(/\/$/,'').endsWith('/cart'))location.reload();
    }
  }
  async function cleanReturnedCart(receipt){
    if(cleaning)return cleaning;
    cleaning=(async()=>{
      const watches=readStored(watchKey).filter(w=>w.createdAt>Date.now()-30*24*3600000);
      const proofs=await Promise.allSettled(watches.map(async watch=>{
        const r=await fetch(`${origin}/api/cart-receipt?token=${encodeURIComponent(watch.token)}`,{credentials:'omit',cache:'no-store',signal:AbortSignal.timeout(1500)});
        return r.ok?await r.json():null;
      }));
      for(let i=0;i<watches.length;i++){
        const watch=watches[i],result=proofs[i];
        if(result.status!=='fulfilled'||!result.value)continue;
        try{const proof=result.value;if(proof.cleanupManaged){if(proof.cartCleared){writeStored(watchKey,readStored(watchKey).filter(w=>w.token!==watch.token));document.dispatchEvent(new CustomEvent('cart:updated',{detail:await cartRead()}));if(location.pathname.replace(/\/$/,'').endsWith('/cart'))location.reload();}continue;}await cleanup(proof,watch);if(readStored(cleanupKey).some(r=>r.orderId===proof.orderId&&r.done))writeStored(watchKey,readStored(watchKey).filter(w=>w.token!==watch.token));}catch{}
      }
      if(receipt)try{const r=await fetch(`${origin}/api/receipt?token=${encodeURIComponent(receipt)}`,{credentials:'omit',cache:'no-store',signal:AbortSignal.timeout(1500)});if(r.ok)await cleanup(await r.json());}catch{}
    })().finally(()=>{cleaning=null;});return cleaning;
  }
  const originalDisabled = new WeakMap();
  const controls = () => [...document.querySelectorAll('button[name="checkout"],input[name="checkout"]')];
  const lock = value => controls().forEach(button => {
    if (value) { originalDisabled.set(button,button.disabled); button.disabled=true; button.setAttribute('aria-busy','true'); }
    else { button.disabled=originalDisabled.get(button) ?? button.disabled; button.removeAttribute('aria-busy'); }
  });
  const capability=()=>{const bytes=crypto.getRandomValues(new Uint8Array(32));return btoa(String.fromCharCode(...bytes)).replace(/\+/g,'-').replace(/\//g,'_').replace(/=+$/,'');};
  const cartHandoff=()=>{
    try{
      const raw=document.cookie.split(';').map(c=>c.trim()).find(c=>c.startsWith('cart='))?.slice(5),cartToken=decodeURIComponent(raw||'');
      if(cartToken.length<16||cartToken.length>512||/[\s\u0000-\u001f;]/.test(cartToken))return '';
      const token=capability();
      const ready=fetch(`${origin}/api/cart-handoff`,{method:'POST',credentials:'omit',keepalive:true,headers:{'Content-Type':'text/plain'},body:JSON.stringify({token,cartToken}),signal:AbortSignal.timeout(2000)}).then(r=>r.ok,()=>false);
      return {token,ready};
    }catch{return null;}
  };
  const nativeRoute=href=>{
    try{
      const url=new URL(href,location.href||'https://www.hatchill.com');
      if(url.protocol!=='https:'||url.username||url.password||url.port||!['www.hatchill.com','hatchill.com','bonsai-eg.myshopify.com'].includes(url.hostname))return null;
      const path=url.pathname.replace(/^\/(en|ar)(?=\/)/,'');
      if(/^\/(?:\d+\/)?checkouts\/(?:cn\/|ac\/)?[A-Za-z0-9_-]{16,}(?:\/recover)?\/?$/.test(path))return {href:`${origin}/checkout#hc_native=${encodeURIComponent(url.href)}`};
      const permalink=path.match(/^\/cart\/(\d+:\d+(?:,\d+:\d+)*)\/?$/);
      if(permalink){const lines=permalink[1].split(',').map(pair=>{const [variantId,qty]=pair.split(':');return {variantId,quantity:Number(qty)};});return {href:`${origin}/checkout#bag=${encodeURIComponent(btoa(JSON.stringify(lines)))}&hc_discount=${encodeURIComponent(url.searchParams.get('discount')||'')}`};}
      if(path==='/checkout'||path==='/checkout/')return {enter:true,href:origin+'/checkout'};
      return null;
    }catch{return null;}
  };
  const routeLinks=()=>{
    for(const anchor of document.querySelectorAll('a[href]')){
      if(anchor.tagName!=='A')continue;
      const original=anchor.dataset.hatchillEntryHref||anchor.dataset.hatchillRecoveryHref;
      const route=original?{href:original,enter:!!anchor.dataset.hatchillEntryHref}:nativeRoute(anchor.getAttribute('href'));
      if(!route)continue;
      if(route.enter){
        anchor.dataset.hatchillCheckout='true';
        if(!original)try{const snapshot=JSON.parse(document.querySelector('button[name="checkout"]')?.value||'null');if(snapshot?.lines?.length&&!snapshot.unsupported)route.href+='#bag='+encodeURIComponent(btoa(JSON.stringify(snapshot.lines)));}catch{}
        anchor.dataset.hatchillEntryHref=route.href;
      }else anchor.dataset.hatchillRecoveryHref=route.href;
      const href=measuredLink(route.href);
      if(anchor.getAttribute('href')!==href)anchor.setAttribute('href',href);
    }
  };
  routeLinks();
  if(typeof MutationObserver!=='undefined')new MutationObserver(routeLinks).observe(document.documentElement,{childList:true,subtree:true});
  async function enter(button) {
    if (busy) return; busy = true; lock(true);
    const offerIntent=button?.dataset?.quietSaleDiscount;if(button?.dataset)delete button.dataset.quietSaleDiscount;
    const handoff=cartHandoff();
    try {
      await cleanReturnedCart();
      const response = await fetch(`${root}cart.js`,{credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(1500)});
      if (!response.ok) throw new Error('cart');
      const cart = await response.json();
      // Preserve unsupported bags rather than silently changing their contents.
      if (!cart.items?.length || cart.items.length>30 || cart.currency!=='EGP' || cart.items.some(item => !Number.isInteger(item.quantity) || item.quantity<1 || item.quantity>10 || item.selling_plan_allocation || item.gift_card || item.item_components?.length || Object.keys(item.properties || {}).length)) throw new Error('unsupported');
      const lines = cart.items.map(item => ({variantId:String(item.variant_id),quantity:item.quantity}));
      const bag = btoa(JSON.stringify(lines));
      let watchParam='';
      try{
        const bytes=crypto.getRandomValues(new Uint8Array(32)),token=btoa(String.fromCharCode(...bytes)).replace(/\+/g,'-').replace(/\//g,'_').replace(/=+$/,'');
        const watches=readStored(watchKey).filter(w=>w.createdAt>Date.now()-30*24*3600000);
        const watch={token,createdAt:Date.now(),cartToken:cart.token,items:cart.items.map(i=>({key:i.key,variantId:String(i.variant_id),quantity:i.quantity}))};
        writeStored(watchKey,[...watches,watch].slice(-10));
        {
          watchParam=`&hc_cart=${token}`;
          // Keepalive survives navigation; no extra step or cart-registration wait.
          fetch(`${origin}/api/cart-source`,{method:'POST',credentials:'omit',keepalive:true,headers:{'Content-Type':'text/plain'},body:JSON.stringify({token,cartToken:cart.token,items:watch.items})}).catch(()=>{});
        }
      }catch{}
      location.assign(`${origin}/checkout#bag=${encodeURIComponent(bag)}${watchParam}${privacyParams()}${attributionParams()}${quietSaleParams(offerIntent,true)}`);
    } catch {
      // Restore the same cart on our server; never route a failure to Shopify.
      // Server-rendered submit data also works before this script has loaded.
      const registered=handoff&&await handoff.ready;
      let fragment=registered?'hc_storefront='+handoff.token:'hc_entry=invalid_cart';
      if(!registered)try{
        const data=JSON.parse(button?.value||'null');
        if(data?.unsupported)fragment='hc_entry=unsupported_cart';
        else if(data?.lines?.length){const updates=button?.form&&new FormData(button.form).getAll('updates[]');if(updates?.length===data.lines.length)data.lines=data.lines.map((line,i)=>({...line,quantity:Number(updates[i])})).filter(line=>line.quantity>0);fragment='bag='+encodeURIComponent(btoa(JSON.stringify(data.lines)));}
      }catch{}
      location.assign(`${origin}/checkout#${fragment}${privacyParams()}${attributionParams()}${quietSaleParams(offerIntent,true)}`);
    } finally { busy=false;lock(false); }
  }
  document.addEventListener('click',event => {
    const button = event.target.closest('button[name="checkout"],input[name="checkout"],a[href]');
    if (!button || button.disabled || event.defaultPrevented || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    if(button.tagName==='A'){
      if(button.dataset.hatchillRecoveryHref){event.preventDefault();event.stopImmediatePropagation();location.assign(measuredLink(button.dataset.hatchillRecoveryHref));return;}
      const route=nativeRoute(button.getAttribute('href'));
      if(button.dataset.hatchillCheckout!=='true'&&!route)return;
      event.preventDefault();event.stopImmediatePropagation();if(route&&!route.enter)location.assign(measuredLink(route.href));else enter();return;
    }
    event.preventDefault(); event.stopImmediatePropagation(); enter(button);
  },true);
  document.addEventListener('submit',event => {
    const button=event.submitter;
    if(button?.disabled)return;
    if(!button?.matches('[name="checkout"]')&&!nativeRoute(event.target?.action||''))return;
    event.preventDefault(); event.stopImmediatePropagation(); enter(button);
  },true);
  const receipt = new URLSearchParams(location.hash.slice(1)).get('hc_receipt');
  if(receipt)history.replaceState(null,'',location.pathname+location.search);
  const run=()=>{const work=()=>cleanReturnedCart(receipt);if(window.navigator?.locks)window.navigator.locks.request('hatchill:cart-receipt',work).catch(()=>{});else work();};
  run();window.addEventListener?.('pageshow',run);
  const privacyReady=()=>{captureTouch();routeLinks();};
  document.addEventListener('visitorConsentCollected',privacyReady);
  window.addEventListener?.('pageshow',privacyReady);
  try{window.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.2'}],privacyReady);}catch{}
  document.addEventListener('visibilitychange',()=>{if(document.visibilityState==='visible')run();});
})();
